export default function InteractionsPageSkeleton() {
  return (
    <div className="flex flex-col gap-6 mt-6">
      <div className="flex flex-col gap-4">
        <div className="animate-pulse h-6 w-32 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        <div className="animate-pulse h-6 w-48 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
      </div>

      {/* Status Badge */}
      <div className="animate-pulse h-6 w-24 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />

      {/* Role and Section Info */}
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-2">
          <div className="animate-pulse h-6 w-6 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          <div className="animate-pulse h-6 w-32 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        </div>
        <div className="flex items-center gap-2">
          <div className="animate-pulse h-6 w-6 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          <div className="animate-pulse h-6 w-48 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        </div>
        <div className="flex items-center gap-2">
          <div className="animate-pulse h-6 w-6 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          <div className="animate-pulse h-6 w-56 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        </div>
      </div>

      {/* View Person Button */}
      <div className="animate-pulse h-10 w-32 rounded-lg bg-gradient-to-r from-gray-200 to-gray-50" />

      {/* Phone Numbers Section */}
      <div className="flex flex-col gap-4">
        <div className="animate-pulse h-6 w-36 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        <div className="flex items-center gap-2">
          <div className="animate-pulse h-6 w-6 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          <div className="animate-pulse h-6 w-32 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          <div className="animate-pulse h-6 w-48 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        </div>
      </div>

      {/* Email Section */}
      <div className="flex flex-col gap-4">
        <div className="animate-pulse h-6 w-24 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        <div className="flex items-center gap-2">
          <div className="animate-pulse h-6 w-6 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          <div className="animate-pulse h-6 w-64 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          <div className="animate-pulse h-6 w-6 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        </div>
      </div>

      {/* Addresses Section */}
      <div className="flex flex-col gap-4">
        <div className="animate-pulse h-6 w-32 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        <div className="flex items-center gap-2">
          <div className="animate-pulse h-6 w-6 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          <div className="animate-pulse h-6 w-24 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        </div>
        <div className="animate-pulse h-6 w-64 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
      </div>

      {/* Employment Section */}
      <div className="flex flex-col gap-4">
        <div className="animate-pulse h-6 w-32 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        <div className="flex items-center gap-2">
          <div className="animate-pulse h-6 w-6 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          <div className="animate-pulse h-6 w-48 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        </div>
        <div className="animate-pulse h-4 w-56 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
      </div>

      {/* Facility Details Section */}
      <div className="flex flex-col gap-4">
        <div className="animate-pulse h-6 w-36 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        <div className="flex items-center gap-2">
          <div className="animate-pulse h-6 w-6 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          <div className="animate-pulse h-6 w-48 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        </div>
      </div>
    </div>
  );
}
